import { render, staticRenderFns } from "./LinkShareButton.vue?vue&type=template&id=4f9813f4&scoped=true&"
import script from "./LinkShareButton.vue?vue&type=script&lang=js&"
export * from "./LinkShareButton.vue?vue&type=script&lang=js&"
import style0 from "./LinkShareButton.vue?vue&type=style&index=0&id=4f9813f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9813f4",
  null
  
)

export default component.exports